<template>
  <div class="modal-invite-form">
    <modal v-model="opened" title="Inviter un utilisateur" size="md" ok-text="Envoyer invitation" cancel-text="Annuler">
      <form>
        <div>
          <label for="">Utilisateur</label>
          <select-2
            class="mx-1" 
            placeholder="Choisir un utilisateur" 
            :endpoint="userSelect2Endpoint"
            @selected="userSelected($event)"
            :dropdownParent="'.modal-invite-form .modal-dialog'" 
            :attributes="{chatroom_id: chatroom.chatroom_id}"
            ref="select-2"
          />
        </div>
      </form>
      <div slot="footer">
        <btn @click="opened=false">Annuler</btn>
        <btn type="primary" @click="confirm" :disabled="confirming">Envoyer invitation</btn>
      </div>
    </modal>
  </div>
</template>

<script>
import Select2 from '../Select2.vue';

export default {
  components: { Select2 },
  name: "chatroom-invite-form",
  props: {
    chatroom: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      opened: false,
      selectedUser: null,
      confirming: false
    }
  },
  computed: {
    userSelect2Endpoint() {
      return `${window.baseUrl}chatroom/select2/uninvited_user_id`;
    },
    modalDialog() {

    }
  },
  methods: {
    open() {
      this.opened = true;
    },
    userSelected(evt) {
      this.selectedUser = evt;
    },
    confirm() {
      this.confirming = true;
      this.$emit("confirm", this.selectedUser);
    },
    dismiss() {
      this.opened = false;
      this.$refs["select-2"].clearSelection();
      this.confirming = false;
    }
  },
}
</script>

<style lang="scss" scoped>

</style>